import axios from "axios"

const apiBlip = axios.create({
    baseURL: "https://http.msging.net"
})

export default apiBlip;